import { Component, EventEmitter, Inject, OnInit, Output } from "@angular/core";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { DataService } from "src/app/data.service";
import { ToastService } from "ng-uikit-pro-standard";
import { TranslationService } from "src/app/translation.service";

export interface GroupTranslations {
  languageCode: string;
  translatedName: string;
}

@Component({
  selector: "app-grouptranslation-dialog",
  templateUrl: "./grouptranslation-dialog.component.html",
  styleUrls: ["./grouptranslation-dialog.component.scss"],
})
export class GrouptranslationDialogComponent implements OnInit {
  translateForm: FormGroup;
  isLoading = false;
  isError = false;
  errorMessage = "";
  languages: any[];

  translatedLabels: any;

  constructor(
    private fb: FormBuilder,
    private dataService: DataService,
    private toastrService: ToastService,
    private translationService: TranslationService,
    private dialogRef: MatDialogRef<GrouptranslationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  @Output() groupTranslationsChanged: EventEmitter<GroupTranslations> =
    new EventEmitter<GroupTranslations>();

  Grouptranslate: GroupTranslations = {
    languageCode: "",
    translatedName: "",
  };

  ngOnInit() {
    console.log("data", this.data);

    if (this.data && this.data.grouptranslation) {
      this.Grouptranslate = { ...this.data.grouptranslation };
    }

    this.translateForm = this.fb.group({
      translate: this.fb.array([]),
      code: "",
      language: "",
    });

    this.addLang();
    this.getLanguage();
  }

  get translate(): FormArray {
    return this.translateForm.get("translate") as FormArray;
  }

  addLang() {
    const translateGroup = this.fb.group({
      languageCode: [
        this.Grouptranslate.languageCode || "",
        Validators.required,
      ],
      translatedName: [
        this.Grouptranslate.translatedName || "",
        Validators.required,
      ],
    });

    this.translate.push(translateGroup);
  }

  getLanguage() {
    const organizationid = localStorage.getItem("crm_orgid");
    const domain = localStorage.getItem(`${organizationid}.domain`);
    const subdomain = localStorage.getItem(`${organizationid}.subdomain`);

    this.isLoading = true;
    this.dataService
      .getOrgLanguage(organizationid, domain, subdomain)
      .subscribe(
        (res) => {
          console.log(res);
          if (res && res.success === 1) {
            const allLanguages = res.data.orglanguage;
            const objArr = [{ value: "", label: "--None--" }];
            for (const lang of allLanguages) {
              objArr.push({ value: lang.code, label: lang.language });
            }
            this.languages = objArr;
            this.isLoading = false;
          } else {
            console.log("Error while fetching languages");
            this.isLoading = false;
            this.showError(res.message);
          }
        },
        (err) => {
          console.log("Error:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          this.showError(err.message);
        }
      );
  }

  showError(message: any) {
    this.toastrService.error(message, "Error");
  }

  selectedLanguageChange(event: { value: string; label: any }) {
    console.log("selectedLanguageChange", event);
    if (event.value.trim() !== "") {
      this.translateForm.controls["code"].setValue(event.value);
      this.translateForm.controls["language"].setValue(event.label);
    } else {
      this.translateForm.controls["code"].setValue("");
      this.translateForm.controls["language"].setValue("");
    }
  }

  translator(index: number) {
    const translateGroup = this.translate.at(index) as FormGroup;
    const selectedLanguage = translateGroup.get("languageCode").value;
    const labelname = this.data.sectionName;

    console.log(selectedLanguage);

    this.translationService
      .translate(labelname, selectedLanguage, "en")
      .subscribe((response: any) => {
        const translatedText = response.data.translations[0].translatedText;
        translateGroup.get("translatedName").setValue(translatedText);
      });
  }

  saveTranslated() {
    if (this.translateForm.valid) {
      console.log("Saving form data:", this.translateForm.value.translate);
      this.translatedLabels = this.translateForm.value.translate;

      const translatedLabel = this.translatedLabels[0];
      this.dialogRef.close(this.Grouptranslate);
      this.groupTranslationsChanged.emit(this.Grouptranslate);

      // this.dialogRef.close({
      //   languagecode: translatedLabel.languageCode,
      //   translatedname: translatedLabel.translatedName,
      // });
    }
    // else {
    //   this.dialogRef.close();
    // }
  }

  removeLang(index: number) {
    this.translate.removeAt(index);
  }

  close() {
    this.dialogRef.close();
  }
}
